/**
 * A company's billing details — what its certified invoices are addressed to:
 * the legal name, the tax id (required for a company, and well formed for its
 * billing country), the billing country (it decides the VAT and, in the EU,
 * whether VIES is asked for the reverse charge) and the address. Stored in
 * `tenant_settings`, synced to Stripe, checked before a checkout opens.
 */
import { z } from 'zod';

import { billingProfileSchema } from './billing-profile';
import { isWellFormedTaxId, taxIdSchema } from './tax-id';

export const companyBillingDetailsSchema = billingProfileSchema
  .safeExtend({
    taxId: taxIdSchema.min(1, 'billing.profile.validation.taxIdRequired'),
  })
  .superRefine((details, ctx) => {
    if (details.taxId && !isWellFormedTaxId(details.country, details.taxId)) {
      ctx.addIssue({
        code: 'custom',
        path: ['taxId'],
        message: 'billing.profile.validation.taxIdInvalid',
      });
    }
  });

export type CompanyBillingDetailsInput = z.infer<typeof companyBillingDetailsSchema>;
